declare const NativeKitCallback: any;

export class NativeKitSystemCallback {
    public static expand(): void {
        NativeKitCallback.postMessage('expand');
    }
}